function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;



/*****************
 ** WEBPACK FOOTER
 ** ./~/raven-js/src/configError.js
 ** module id = 563
 ** module chunks = 0
 **/